import * as actions from './recipeActions';

const initialState = {
  myRecipes: [],
  publicRecipes: [],
  selectedRecipe: null,
  currentView: 'my-recipes', // 'my-recipes' | 'community-library'
  loading: false,
  error: null,
  success: null,
};

// For backward compatibility
export const getRecipes = (state) => state.myRecipes;

export default function recipeReducer(state = initialState, action) {
  switch (action.type) {
    // CREATE RECIPE
    case actions.CREATE_RECIPE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case actions.CREATE_RECIPE.SUCCESS:
      return {
        ...state,
        loading: false,
        myRecipes: [action.payload.data, ...state.myRecipes],
        success: 'Recipe created successfully',
      };
    case actions.CREATE_RECIPE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // UPDATE RECIPE
    case actions.UPDATE_RECIPE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case actions.UPDATE_RECIPE.SUCCESS:
      return {
        ...state,
        loading: false,
        myRecipes: state.myRecipes.map((recipe) =>
          recipe.id === action.payload.data.id ? action.payload.data : recipe
        ),
        selectedRecipe: action.payload.data,
        success: 'Recipe updated successfully',
      };
    case actions.UPDATE_RECIPE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // DELETE RECIPE
    case actions.DELETE_RECIPE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case actions.DELETE_RECIPE.SUCCESS:
      return {
        ...state,
        loading: false,
        myRecipes: state.myRecipes.filter((recipe) => recipe.id !== action.payload.id),
        selectedRecipe: null,
        success: 'Recipe deleted successfully',
      };
    case actions.DELETE_RECIPE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // GET RECIPES BY ORGANIZATION
    case actions.GET_RECIPES_BY_ORG.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_RECIPES_BY_ORG.SUCCESS:
      return {
        ...state,
        loading: false,
        myRecipes: action.payload.data,
      };

    // GET MY RECIPES
    case actions.GET_MY_RECIPES.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_MY_RECIPES.SUCCESS:
      return {
        ...state,
        loading: false,
        myRecipes: action.payload.data,
      };
    case actions.GET_MY_RECIPES.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // GET PUBLIC RECIPES
    case actions.GET_PUBLIC_RECIPES.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_PUBLIC_RECIPES.SUCCESS:
      return {
        ...state,
        loading: false,
        publicRecipes: action.payload.data,
      };
    case actions.GET_PUBLIC_RECIPES.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // DUPLICATE RECIPE
    case actions.DUPLICATE_RECIPE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case actions.DUPLICATE_RECIPE.SUCCESS:
      return {
        ...state,
        loading: false,
        myRecipes: [action.payload.data, ...state.myRecipes],
        success: 'recipes.recipe_downloaded',
      };
    case actions.DUPLICATE_RECIPE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // PUBLISH RECIPE
    case actions.PUBLISH_RECIPE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case actions.PUBLISH_RECIPE.SUCCESS:
      return {
        ...state,
        loading: false,
        myRecipes: state.myRecipes.map((recipe) =>
          recipe.id === action.payload.data.id ? action.payload.data : recipe
        ),
        selectedRecipe: action.payload.data,
        success: 'Recipe visibility updated successfully',
      };
    case actions.PUBLISH_RECIPE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // SET RECIPE VIEW
    case actions.SET_RECIPE_VIEW:
      return {
        ...state,
        currentView: action.payload,
      };
    case actions.GET_RECIPES_BY_ORG.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // UI STATE
    case actions.SET_SELECTED_RECIPE:
      return {
        ...state,
        selectedRecipe: action.payload,
      };

    case actions.RESET_RECIPES_STATE:
      return initialState;

    case actions.CLEAR_RECIPE_MESSAGES:
      return {
        ...state,
        success: null,
        error: null,
      };

    // LIKE RECIPE
    case actions.LIKE_RECIPE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.LIKE_RECIPE.SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.data.liked ? 'Recipe liked' : 'Recipe unliked',
      };
    case actions.LIKE_RECIPE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // SHARE RECIPE
    case actions.SHARE_RECIPE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.SHARE_RECIPE.SUCCESS:
      return {
        ...state,
        loading: false,
        success: 'Link copied to clipboard',
      };
    case actions.SHARE_RECIPE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // SEARCH PUBLIC RECIPES
    case actions.SEARCH_PUBLIC_RECIPES.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.SEARCH_PUBLIC_RECIPES.SUCCESS:
      return {
        ...state,
        loading: false,
        publicRecipes: action.payload.data,
      };
    case actions.SEARCH_PUBLIC_RECIPES.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // SET FILTERS
    case actions.SET_RECIPE_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };

    default:
      return state;
  }
}
